.list {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
  margin: 0.5rem 0;
}

.item-title {
  font-variant-numeric: tabular-nums;
  color: var(--fg-dim);
}

.item-content {
  margin: 0;
}

.post-title {
  font-size: var(--font-size);
  font-weight: var(--font-weight-bold);
}

.post-summary {
  margin-top: 0.125rem;
}

.footer {
  text-align: center;
}

@media screen and (width < 600px) {
  .list {
    display: block;
  }

  .item-content {
    margin: 0.125rem 0 1.5rem 1rem;
  }
}
